import PropTypes from 'prop-types'

import { BlockWrapper, Container } from 'common/widgets'


Quote.propTypes = {
  data: PropTypes.shape({
    quote: PropTypes.string,
    signature: PropTypes.string,
    author: PropTypes.string,
  }),
}

export default function Quote({
  data = {},
}) {
  return (
    <BlockWrapper spacing="text">
      <Container size="xl">
        <blockquote>{data.quote}</blockquote>
        <p>{data.author}</p>
        <p>{data.signature}</p>
      </Container>
    </BlockWrapper>
  )
}
